var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-wrapper"},[_c('Spinner',{attrs:{"spacing":15,"font-size":16,"message":_vm.message,"text-fg-color":"#fff"}}),(_vm.hideable)?_c('a',{staticClass:"close-spinner",attrs:{"href":"javascript:;"},on:{"click":_vm.hideLoader}},[_vm._v(_vm._s(_vm.__('hide')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }